import { Component, inject, ElementRef, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarService } from './sidebar.service';

@Component({
  selector: 'lib-sidebar-portal-host',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div #contentHost
         class="sidebar-portal-host h-full overflow-x-hidden"
         [class.switching]="sidebarService.isSwitchingMode()"
         [class.fade-in]="sidebarService.contentReady() && sidebarService.showSplitView()">
    </div>
  `,
  styles: [`
    .sidebar-portal-host {
      opacity: 0;
      transition: opacity 150ms ease-out;
      background: #F9F9F9;
      overflow-y: auto;
      height: 100%;
    }
    .sidebar-portal-host.fade-in {
      opacity: 1;
    }
    .sidebar-portal-host.switching {
      opacity: 0;
    }
  `]
})
export class SidebarPortalHostComponent implements OnDestroy, AfterViewInit {
  readonly sidebarService = inject(SidebarService);

  @ViewChild('contentHost')
  contentHost!: ElementRef<HTMLElement>;

  ngAfterViewInit(): void {
    this.sidebarService.registerSplitViewHost(this.contentHost.nativeElement);
  }

  ngOnDestroy(): void {
    this.sidebarService.unregisterSplitViewHost();
  }
}
